// Copyright ©️ 2025 eVolve MEP, LLC

import { useCallback, useEffect, useState } from 'react';

import { Checkbox } from '@mantine/core';
import type { GridApi } from 'ag-grid-enterprise';

import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';

export const DeselectAllCheckbox = ({ api }: { api: GridApi }) => {
  const [enabled, setEnabled] = useState(false);

  const onSelectionChanged = useCallback(({ api: innerApi }: { api: GridApi }) => {
    setEnabled(innerApi.getSelectedRows().length > 0);
  }, []);

  useEffect(() => {
    api.addEventListener('selectionChanged', onSelectionChanged);
    return () => {
      if (!api.isDestroyed()) {
        api.removeEventListener('selectionChanged', onSelectionChanged);
      }
    };
  }, [api, onSelectionChanged]);

  return (
    <AgGridStyleTooltip label="Deselect all" withArrow openDelay={400}>
      <Checkbox
        checked
        indeterminate
        disabled={!enabled}
        onChange={() => api.deselectAll()}
        size="xs"
        styles={{
          input: {
            cursor: enabled ? 'pointer' : 'initial',
          },
        }}
      />
    </AgGridStyleTooltip>
  );
};
